/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy, Input, OnDestroy, OnChanges } from '@angular/core';
import Point from '@appLegacy/lib/math/Point';
import { interval, BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';

@Component({
	selector: 'app-zoom-control',
	templateUrl: './zoom-control.component.html',
	styleUrls: ['./zoom-control.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZoomControlComponent implements OnDestroy, OnChanges {
	@Input() public hud: any;
	@Input() public scaleToFit: () => any;
	@Input() public zoomPower = 0.35;
	@Input() public styleClass: object;

	private shutdownSubject$: Subject<void> = new Subject();

	public ngOnDestroy() {
		this.shutdownSubject$.next();

		this.shutdownSubject$.complete();
	}

	public ngOnChanges(changes) {
		// the input change from JS is only available in OnChange
		if (changes) {
			if (changes.hud) {
				this.hud = changes.hud.currentValue;
			}
			if (changes.scaleToFit) {
				this.scaleToFit = changes.scaleToFit.currentValue;
			}
			if (changes.styleClass) {
				this.styleClass = changes.styleClass.currentValue;
			}
		}
	}

	public zoomIn() {
		this.hud.zoomIn ? this.hud.zoomIn(this.zoomPower, true) : this.zoom(this.zoomPower * 1.2);
	}

	public zoomOut() {
		this.hud.zoomOut ? this.hud.zoomOut(this.zoomPower, true) : this.zoom(-this.zoomPower);
	}

	public seeAll() {
		if (this.scaleToFit) {
			this.scaleToFit();
		}
	}

	private zoom(zoomOffset) {
		const z = 1 + zoomOffset;
		const c = new Point(window.innerWidth / 2, window.innerHeight / 2);

		this.hud.startAnimation();
		this.hud.scale(z, c);

		interval(500)
			.pipe(take(1), takeUntil(this.shutdownSubject$))
			.subscribe(() => {
				this.hud.endAnimation();
			});

		analyticsEventsService.clickedZoomButton();
	}
}
